// extracted by mini-css-extract-plugin
export default {"popup":"SidebarPopup_popup__2BpZM"};